module.exports = __webpack_public_path__ + "static/media/GBR Processing (DTN Network) - DTN Network - 26-08-2024 C.ee3829ae.gif";